import toast from "react-hot-toast";
import axiosInstance from "../../../axiosInstance";

export const getFeaturedTours = (setFormData) => {
  axiosInstance
    .get("/tours/featured-tours")
    .then((res) => {
      if (res.data.tours) {
        setFormData(res.data.tours);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
export const getAllTours = (setTourData, Page, Limit, setPageData) => {
  axiosInstance
    .get(`/tours/all-tours?page=${Page}&limit=${Limit}`)
    .then((res) => {
      setTourData(res.data.data);
      setPageData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getDetails = (setTourData, id, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .get(`/tours/details/${id}`)
    .then((res) => {
      if (res.data.data) {
        setTimeout(() => {
          setTourData(res.data);
          setIsLoading(false);
        }, 2000);
      }
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
